import styled from 'styled-components';

import { EditOutline } from '@simplywallst/ui-core/icons';

export const EditIcon = styled(EditOutline)`
  fill: ${({ theme }) => theme.color.brand01};
  transform: translateY(1px);
`;
